import { ErcType as e } from "../constants/erc.js";
import * as r from "yup";
const c = r.mixed().oneOf(Object.values(e)).default(e.erc721);
export {
  c as ercTypeSchema
};
//# sourceMappingURL=erc.js.map
